import { useTheme } from '@mui/material'

const SignalIcon = ({ value, isOffline, ariaLabel, warningColor }: { value: number; isOffline?: boolean; ariaLabel?: string; warningColor?: string }) => {
  const theme = useTheme()
  const channelIconColor = (color: string) => (isOffline ? theme.palette.action.disabled : color)
  const getColor = (color: string) => channelIconColor(color)

  const bar1Color =
    value === 1
      ? getColor(theme.palette.error.main)
      : value === 2
        ? getColor(warningColor ?? theme.palette.warning.light)
        : value > 2
          ? getColor(theme.palette.success.main)
          : getColor('black')

  const bar2Color = value === 1 ? getColor('black') : value === 2 ? getColor(warningColor ?? theme.palette.warning.light) : getColor(theme.palette.success.main)
  const bar2Opacity = value === 1 ? 0.12 : 1

  const bar3Color = value < 3 ? getColor('black') : getColor(theme.palette.success.main)
  const bar3Opacity = value < 3 ? 0.12 : 1

  const bar4Color = value < 4 ? getColor('black') : getColor(theme.palette.success.main)
  const bar4Opacity = value < 4 ? 0.12 : 1

  const bar5Color = value < 5 ? getColor('black') : getColor(theme.palette.success.main)
  const bar5Opacity = value < 5 ? 0.12 : 1

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel}>
      <path
        d="M2.52632 12.5C2.52632 12.2239 2.30246 12 2.02632 12H0.5C0.223858 12 0 12.2239 0 12.5V15.5C0 15.7761 0.223858 16 0.5 16H2.02632C2.30246 16 2.52632 15.7761 2.52632 15.5V12.5Z"
        fill={bar1Color}
        fillOpacity="1"
      />
      <path
        d="M3.36842 9.5C3.36842 9.22386 3.59228 9 3.86842 9H5.39474C5.67088 9 5.89474 9.22386 5.89474 9.5V15.5C5.89474 15.7761 5.67088 16 5.39474 16H3.86842C3.59228 16 3.36842 15.7761 3.36842 15.5V9.5Z"
        fill={bar2Color}
        fillOpacity={bar2Opacity}
      />
      <path
        d="M9.26362 6.5C9.26362 6.22386 9.03976 6 8.76362 6H7.2373C6.96116 6 6.7373 6.22386 6.7373 6.5V15.5C6.7373 15.7761 6.96116 16 7.23731 16H8.76362C9.03976 16 9.26362 15.7761 9.26362 15.5V6.5Z"
        fill={bar3Color}
        fillOpacity={bar3Opacity}
      />
      <path
        d="M12.632 3.5C12.632 3.22386 12.4082 3 12.132 3H10.6057C10.3296 3 10.1057 3.22386 10.1057 3.5V15.5C10.1057 15.7761 10.3296 16 10.6057 16H12.132C12.4082 16 12.632 15.7761 12.632 15.5V3.5Z"
        fill={bar4Color}
        fillOpacity={bar4Opacity}
      />
      <path
        d="M16.0009 0.5C16.0009 0.223858 15.7771 0 15.5009 0H13.9746C13.6985 0 13.4746 0.223858 13.4746 0.5V15.5C13.4746 15.7761 13.6985 16 13.9746 16H15.5009C15.7771 16 16.0009 15.7761 16.0009 15.5V0.5Z"
        fill={bar5Color}
        fillOpacity={bar5Opacity}
      />
    </svg>
  )
}

export default SignalIcon
